import { render, staticRenderFns } from "./TurnoverChat.vue?vue&type=template&id=169f8062&"
import script from "./TurnoverChat.vue?vue&type=script&lang=js&"
export * from "./TurnoverChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports